// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/main.styl
// module id = 5
// module chunks = 0